define((require) => {
    "use strict";

    var ViewController   = require("editor/util/ViewController"),
        Storage          = require("shared/services/Storage"),
        GeneralFunctions = require("editor/util/GeneralFunctions"),
        _                = require("underscore");

    /**
     * The view rendering a social sharing widget.
     *
     * @class SocialSharingWidgetView
     *
     * @cfg {SocialSharingWidgetModel} model The model of the social sharing icon being rendered.
     */
    return ViewController.extend({

        onInitialize: function() {
            this.listenTo(this.model, "change:style change:networks", function(model) {
                this._updateLastUsedProperties(model);
            });
        },

        /**
         * Updates the last used properties in relation to order choice (networks) and selected style.
         * @param {Object} model - The changed model.
         */
        _updateLastUsedProperties: function(model) {
            if (model.changed) {
                var lastUsedProperties = _.pick(
                    model.changed,
                    "style",
                    "networks"
                );

                if (_.isEmpty(lastUsedProperties)) {
                    return;
                }

                Storage.Local.update(Storage.Keys.LAST_USED_SOCIAL_PROPERTIES, GeneralFunctions.compactObject(lastUsedProperties));
            }
        },

        /**
         * Handles add and removes of social networks from the Editor.
         * @param {object} event - the current event.
         */
        onViewChangeEditorSelect: function(event) {
            var networks;

            if (event.added) {
                networks = _.clone(this.model.get("networks"));
                networks.push(event.added.id);

                this.model.set("networks", networks);
            } else if (event.removed) {
                networks = this.model.get("networks");
                var id = event.removed.id;

                if (_.contains(networks, id)) {
                    // _.without returns a clone networks.
                    this.model.set("networks", _.without(networks, id));
                }
            }
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/widgets/socialSharingWidget/SocialSharingWidgetViewController.js